import React from 'react'
import Navbar from '../Navbar/Navbar'
import Mainslider from '../slider/Mainslider'
import Homemain from '../Homemain/Homemain'
import Testimonial from '../testimonial/Testimonial'
import Footer from '../footer/Footer'

function Home() {
    return (
        <>
            <Navbar />
            <Mainslider />
            <Homemain />
            <Testimonial />
            <Footer />
        </>
    )
}

export default Home
